// @flow
import React from 'react';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import BurgerMenuItem from '../BurgerMenuItem/BurgerMenuItem';
import withSelectedCategoryId from '../../../HOC/withSelectedCategoryId/withSelectedCategoryId';
import styles from './BurgerMenu.module.css';

import type { MenuItem } from '../menuItems';

type OwnProps = {|
  +menuItems: Array<MenuItem>,
  +handleCategoryTracking: (string) => void,
|};

type InjectedProps = {|
  +selectedCategoryId: string | null,
|};

type Props = {|
  ...OwnProps,
  ...InjectedProps,
|};

type State = {|
  +menuOpen: boolean,
  +expandedCategories: Set<string | null>,
|};

class BurgerMenu extends React.Component<Props, State> {
  state = {
    menuOpen: false,
    expandedCategories: new Set(['add-ons/edit']),
  };

  burgerMenuContainer = React.createRef<HTMLElement>();

  toggleMenu = () => {
    const handleToggleMenu = (state) => {
      const menuShouldOpen = !state.menuOpen;
      if (menuShouldOpen) {
        disableBodyScroll(this.burgerMenuContainer.current);
      } else {
        clearAllBodyScrollLocks();
      }
      return {
        menuOpen: menuShouldOpen,
      };
    };

    this.setState(handleToggleMenu);
  };

  toggleCategoryExpansion = (categoryId: string | null) => {
    const expandedCategories = new Set(this.state.expandedCategories);
    if (expandedCategories.has(categoryId)) {
      expandedCategories.delete(categoryId);
    } else {
      expandedCategories.add(categoryId);
    }

    this.setState({ expandedCategories });
  };

  render() {
    const { menuOpen, expandedCategories } = this.state;
    const {
      menuItems,
      selectedCategoryId,
      handleCategoryTracking,
    } = this.props;
    return (
      <React.Fragment>
        <button
          className={`${styles.burgerButton} naked-button`}
          onClick={this.toggleMenu}
          type="button"
        >
          <span className="sr-only">open menu</span>
        </button>
        <section
          className={`${styles.burgerMenu} ${menuOpen ? styles.menuOpen : ''}`}
          ref={this.burgerMenuContainer}
        >
          <header className={styles.menuHeader}>
            <a className={styles.homeLink} href="/">
              <span className="sr-only">navigate to home page</span>
              <img
                alt="FabFitFun Logo"
                src="https://static.fabfitfun.com/wp-content/themes/fabfitfun/images/fff-logo.png"
              />
            </a>
            <button
              className={`${styles.closeButton} naked-button`}
              onClick={this.toggleMenu}
              type="button"
            >
              <i className="fal fa-times" />
              <span className="sr-only">close menu</span>
            </button>
          </header>
          <ul className={styles.menuItems}>
            {menuItems.map((menuItem) => (
              <BurgerMenuItem
                key={menuItem.id}
                isNotCategory={menuItem.isNotCategory || false}
                children={menuItem.children}
                categoryId={menuItem.id}
                name={menuItem.name}
                live={menuItem.live || false}
                primaryItem
                isChild={false}
                path={menuItem.path}
                selectedCategoryId={selectedCategoryId}
                toggleMenu={this.toggleMenu}
                isOpenByDefault={menuItem.areChildrenCategories}
                expandedCategories={expandedCategories}
                toggleCategoryExpansion={this.toggleCategoryExpansion}
                handleCategoryTracking={handleCategoryTracking}
              />
            ))}
          </ul>
        </section>
      </React.Fragment>
    );
  }
}

export default withSelectedCategoryId<OwnProps>(BurgerMenu);
